<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('solutions')" class="breadcrumb  px-2">
          {{ $t('OUR_SOLUTIONS') }}</nuxt-link
        >
        <nuxt-link
          :to="
            localePath({
              name: 'solution-slug',
              params: { slug: solution.slug }
            })
          "
          class="breadcrumb  px-2"
        >
          {{ solution.name[this.$i18n.locale] }}</nuxt-link
        >
      </div>
    </div>
    <div
      :style="`background: url('/img/solution-headers/${solution.slug}.jpg')`"
      class="header text-center py-32"
    >
      <h1 class="text-4xl text-white font-bold">
        {{ solution.name[this.$i18n.locale] }}
      </h1>
    </div>
    <section class="solution px-4 container mx-auto ">
      <div class="solution-content bg-white px-8 py-8 md:px-20 md:py-20">
        <h3 class="text-2xl font-semibold mb-4">{{ $t('overview') }}</h3>
        <p class="text-grey-600 mb-5">
          {{ solution.description[this.$i18n.locale] }}
        </p>
        <div
          v-html="solution.additional_info[this.$i18n.locale]"
          class="additional-info"
        ></div>
      </div>
      <div class="text-center my-6 pb-4">
        <h4 class="font-bold text-2xl ">
          {{ $t('anything_you_need_help') }}
        </h4>
        <div class="flex flex-wrap justify-center">
          <nuxt-link
            :to="localePath('solutions')"
            class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
            >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
          >
          <nuxt-link
            :to="localePath('contact')"
            class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
            >{{ $t('contact') }}</nuxt-link
          >
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import solutions from '~/static/solutions.json'

export default {
  data() {
    return {}
  },
  asyncData({ route, params }) {
    const slug = params.slug
    const solution = solutions.find(solution => {
      return solution.slug === slug
    })

    return { solution }
  },
  mounted() {}
}
</script>

<style scoped>
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: -1;
}
.header .text-4xl {
  margin-top: -50px;
}
.solution-content {
  transform: translateY(-75px);
  z-index: 999;
}
.card {
  display: flex;
  margin-bottom: 35px;
  min-height: 300px;
  /* max-height: 350px; */
}
.card img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}
.additional-info h3 {
  @apply my-3;
  @apply font-bold;
}
.additional-info p {
  background: red;
}
@screen md {
  .card:nth-child(odd) {
    flex-direction: row-reverse;
  }

  .card:nth-child(even) div {
    padding-left: 25px;
    padding-right: 0;
  }
  .card img {
    width: 50%;
    height: auto;
    max-height: 350px;
  }
  .card div {
    padding-right: 25px;
    width: 50%;
  }
}
</style>
